import { render, staticRenderFns } from "./TalentAnalysis.vue?vue&type=template&id=7a77cd22&"
import script from "./TalentAnalysis.vue?vue&type=script&lang=js&"
export * from "./TalentAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports